/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./editCommands.vue?vue&type=template&id=767c2078&scoped=true&"
import script from "./editCommands.vue?vue&type=script&lang=js&"
export * from "./editCommands.vue?vue&type=script&lang=js&"
import style0 from "./editCommands.vue?vue&type=style&index=0&id=767c2078&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767c2078",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VChip,VCol,VCombobox,VIcon,VListItemContent,VRow,VSelect})
